<!--TeActivityStudent:学生自学动态 2021/08/17 11:07:53 YuAng-->

<template>
  <div class="its-te-activty">
    <el-select v-model="params.classId" placeholder="班级" size="small" @change="loadActivityStatistics">
      <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="params.subjectId" placeholder="学科" size="small" @change="loadActivityStatistics">
      <el-option v-for="item in subjects" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
    <p class="its-part-title">
      <span>本月自学概况</span>
      <span class="empty">（截止昨日24:00）</span>
    </p>
    <!-- 单班级 -->
    <div v-if="report.classUseTimes.length === 1" class="te-study-chart">
      <el-progress type="circle" :percentage="report.classUseTimes[0].value * 100 / report.classUseTimes[0].total" :width="128" :stroke-width="12" :show-text="false"></el-progress>
      <p class="te-chart-tip">
        <span style="color: #389CFF;font-size: 21px">{{ report.classUseTimes[0].value }}</span>
        <span style="color: #AAAAAA ">/{{ report.classUseTimes[0].total }}</span>
      </p>
      <p class="te-chart-tip" style="top: 76px">自学学生数</p>
    </div>
    <!-- 多班级 -->
    <div v-else-if="timesCount > 0" class="te-study-chart" style="height: 200px">
      <div class="te-chart-container">
        <div ref="chart" style="width: 100%;height: 100%"></div>
      </div>
    </div>
    <div-no-data v-else class="te-study-chart" style="height: 260px;margin-left:10%">
      <p class="empty">本月学生还没有自学,老师快去提醒一下吧 </p>
    </div-no-data>
    <p v-if="report.studyRanks.length > 0" class="its-part-title">
      <span>本月个人勤学榜</span>
      <span class="empty">（截止昨日24:00）</span>
    </p>
    <ul v-if="report.studyRanks.length > 0" class="te-stu-ranks">
      <li v-for="(item,index) in report.studyRanks" :key="'li' + index">
        <span :class="'te-stu index' + index">{{ index + 1 }}</span>
        <span class="te-stu-name" :title="item.name">{{ item.name }}</span>
        <span>{{ item.value }}次</span>
      </li>
    </ul>
    <p class="its-part-title">
      <span>学生学习动态</span>
    </p>
    <ul v-if="activtys && activtys.length > 0">
      <li v-for="(item,index) in activtys" :key="'activty' + index">
        <p class="its-te-title" :title="item.content">
          <span class="span-point">· </span>
          <span style="color: black">{{ item.userName }}</span>
          <span>{{ item.content }}</span>
        </p>
        <p class="its-te-date">{{ item.time | formatDate('M-d hh:mm') }}</p>
      </li>
    </ul>
    <div-no-data v-else>
      <p v-if="promise" class="empty">
        数据加载中...
      </p>
      <template v-else>
        <p class="empty">学生还没有自学，老师快去提醒一下吧~</p>
      </template>
    </div-no-data>
  </div>
</template>
<script>
import { teacherHomeApi } from '@/utils/api'
import DivNoData from '../../../components/DivNoData.vue'

export default {
  components: { DivNoData },
  name: 'TeActivityStudent',
  data() {
    return {
      activtys: [],
      promise: null,
      classList: [
        {
          id: 0,
          name: '不限班级'
        }
      ],
      subjects: [
        {
          id: 0,
          name: '不限学科'
        }
      ],
      params: {
        classId: 0,
        subjectId: 0,
        currentPage: 1,
        pageSize: 10
      },
      report: {
        studyRanks: [],
        studentUseTimes: [],
        classUseTimes: []
      },
      timesCount: 0
    }
  },
  created() {
    this.loadClass()
    this.loadSubject()
  },
  mounted() {
    this.loadActivityStatistics()
  },
  methods: {
    loadActivity: function () {
      this.promise = teacherHomeApi.getStudentNews(this.params).then((resp) => {
        if (resp.success) {
          if (resp.body.items && resp.body.items.length > 0) {
            for (let i = 0; i < resp.body.items.length; i++) {
              this.setContent(resp.body.items[i])
            }
          }
        }
        this.activtys = resp.body.items
      })
      setTimeout(() => {
        this.promise = null
      }, 2 * 1000);
    },
    loadClass: function () {
      teacherHomeApi.getActivityClassList().then(resp => {
        if (resp.body) {
          const all = { id: 0, name: '不限班级' }
          resp.body.unshift(all)
          this.classList = resp.body
        }
      })
    },
    loadSubject: function () {
      teacherHomeApi.getActivitySubjects().then(resp => {
        if (resp.body) {
          resp.body.unshift({
            id: 0,
            name: '不限学科'
          })
        }
        this.subjects = resp.body
      })
    },
    loadActivityStatistics: function () {
      this.timesCount = 0
      this.loadActivity()
      teacherHomeApi.getActivityStatistics(this.params.subjectId, this.params.classId).then(resp => {
        if (resp.body) {
          this.report = resp.body
          if (resp.body.classUseTimes && resp.body.classUseTimes.length > 1) {
            this.$nextTick(() => {
              this.setChart(this.report.classUseTimes);
            })
          }
        }
      })
    },
    setContent: function (item) {
      const actions = {
        LESSON_REPEAT: '朗读了“' + item.title + '”的课文',
        WORD_REPEAT: '朗读了“' + item.title + '”的单词',
        PHONETIC: '挑战了音标“' + item.title + '”',
        ENGLISH_READ_TRAINING: '阅读了英语“' + item.title + '”',
        TRAIN_SUBMIT: '完成了' + item.courseName + '”' + item.title + '”的巩固练习',
        LISTENING: '练习了' + item.courseName + '”' + item.title + '”的听力练习',
        EXAM_PRACTICE: '练习了' + item.courseName + '”' + item.title + '”的备考练习',
      }
      item.content = actions[item.scenes] ? actions[item.scenes] + this.showRate(item) : '学了' + item.courseName
    },
    showRate: function (item) {
      if (!item.correctRate || item.correctRate < 0.6) {
        return ''
      }
      const rate = parseInt(item.correctRate * 100)
      if (item.scenes === 'TRAIN_SUBMIT') {
        return '，共' + item.questionCount + '道题，正确率' + rate + '%'
      } else if (item.scenes === 'EXAM_PRACTICE' || item.scenes === 'LISTENING') {
        return '，正确率' + rate + '%'
      } else {
        return '，获得了' + rate + '分'
      }
    },
    setChart: function (items) {
      const option = {
        tooltip: {
          show: true,
          formatter: params => {
            const { name, value, total } = params.data
            return name + '：' + value + '人/' + total + '人'
          },
          textStyle: {
            color: "#AAAAAA",
            fontSize: 12
          }
        },
        grid: {
          left: 20,
          right: 20,
          top: 30,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          splitLine: { show: false },
          axisLine: { show: true, lineStyle: { color: '#D8D8D8 ' } },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            interval: 0,
            rotate: 40,
            textStyle: {
              fontSize: 10,
              color: '#AAAAAA'
            }
          }
        },
        yAxis: {
          type: 'value',
          minInterval: 1
        },
        series: [{
          data: [],
          // 柱顶部显示数字
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'top',
                formatter: '{c}人',
                textStyle: {
                  color: '#707070',
                  fontSize: 12
                }
              }
            }
          },
          barWidth: 28,
          type: 'bar',
          color: '#389CFF'
        }]
      }
      let total = 0
      for (let index = 0; index < items.length; index++) {
        const element = items[index]
        const title = element.name.length > 5 ? element.name.substr(0, 5) + '...' : element.name
        option.xAxis.data.push(title)
        total = total + element.value
        option.series[0].data.push(element)
      }
      this.timesCount = total
      this.$nextTick(() => {
        if (total && this.$refs.chart) {
          /* eslint-disable-next-line */
          const chart = echarts.init(this.$refs.chart)
          const width = items.length * 56 < 340 ? 340 : items.length * 56
          chart.resize({ height: 200, width: width })
          chart.setOption(option)
        }
      })
    }
  }
}


</script>

<style scoped>
.its-te-activty ul {
  padding: 0 20px;
}

.its-te-activty li {
  width: 100%;
  margin-bottom: 8px;
  overflow: hidden;
}

.its-te-title {
  float: left;
  width: calc(100% - 100px);
  padding: 0 10px;
  color: #757575;
  position: relative;
  line-height: 1.5;
}

.its-te-title .span-point {
  font-weight: bold;
  color: black;
  position: absolute;
  left: 1px;
  top: -1px;
}

.its-te-date {
  float: left;
  width: 100px;
  text-align: right;
  color: #757575;
}

.its-te-activty >>> .el-select {
  width: 107px;
  margin: 20px 0 0 20px;
}

/* 下拉框箭头强制改成实心的 */
.its-te-activty >>> .el-icon-arrow-up:before {
  content: "\e78f";
}

.te-study-chart {
  height: 144px;
  text-align: center;
  font-size: 12px;
  position: relative;
}

.te-chart-container {
  height: 100%;
  width: cal(100% -32px);
  overflow-y: hidden;
  overflow-x: auto;
  margin: 0 8px;
}

.te-study-chart >>> .el-progress {
  display: inline-block;
  margin-top: 10px;
}

.te-chart-tip {
  position: absolute;
  top: 50px;
  width: 100%;
}

.te-stu-ranks {
  padding-top: 20px !important;
}

.te-stu-ranks li {
  display: inline-block;
  width: 50%;
  height: 30px;
}

.te-stu-ranks li span {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
}

.te-stu-name {
  margin-left: 10px;
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.te-stu {
  font-style: normal;
  float: left;
  width: 14px;
  height: 20px;
  background-size: 100%;
  text-align: center;
  margin-top: 2px;
}

.te-stu.index0 {
  background-image: url("../../../../assets/images/teacher-rank1.png");
  color: transparent;
  margin-top: 0px;
}

.te-stu.index1 {
  background-image: url("../../../../assets/images/teacher-rank2.png");
  color: transparent;
  margin-top: 0px;
}

.te-stu.index2 {
  background-image: url("../../../../assets/images/teacher-rank3.png");
  color: transparent;
  margin-top: 0px;
}
</style>
